import cx from "clsx"
import { Card, Flex, Icon, Text } from "components/common"
import { memo, useMemo } from "react"
import styles from "../../index.module.less"
import { formatMessageTime, getMessageStatus, getTickIcon } from "../../utils"
import ReplyPreview from "../ReplyPreview"

export const BasicCard = memo((props) => {
  const { msg, children, isLoading = false, cardProps = {}, client, selectedStaff } = props
  const isMe = msg?.sentBy === "staff"
  const rowClass = isMe ? styles.msgRowMe : styles.msgRowOther
  const bubbleClass = isMe ? "msgBubbleMe" : "msgBubbleOther"
  const isOverlay = cardProps?.overlayTimeAndTick
  const hideTimeAndTick = cardProps?.hideTimeAndTick
  const videoDuration = cardProps?.videoDuration

  const formattedDuration = useMemo(() => {
    if (!videoDuration) return null
    const durationInSeconds = typeof videoDuration === 'string' ?
      parseFloat(videoDuration) : videoDuration
    if (isNaN(durationInSeconds) || durationInSeconds <= 0) return null
    const minutes = Math.floor(durationInSeconds / 60)
    const seconds = Math.floor(durationInSeconds % 60)
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }, [videoDuration])

  const timeAndTickContent = (
    <>
      <span
        className={cx(styles.msgTime, isOverlay && styles.overlayTimeText)}
      >
        {formatMessageTime(msg?.messageTimestamp)}
      </span>
      {isMe && getTickIcon(
        getMessageStatus(msg),
        isOverlay ? { ...styles, tickColor: "white" } : styles
      )}
    </>
  )

  return (
    <div className={rowClass}>
      <div className={isOverlay ? styles.overlayContainer : styles.staticContainer}>
        <Card
          {...cardProps}
          className={cx(bubbleClass, cardProps.className)}
          bordered={false}
          bodyStyle={cardProps?.removeExtraPadding ? { padding: 0 } : {}}
        >
          {msg?.repliedToMessageId && (
            <div className={"pi-8 pb-8"}>
              <ReplyPreview
                msg={msg}
                repliedToMessage={msg?.RepliedToMessage}
                client={client}
                selectedStaff={selectedStaff}
              />
            </div>
          )}

          {children}

          {!isLoading && isOverlay && (
            <>
              {formattedDuration && (
                <Flex
                  align="center"
                  justify="center"
                  gap="4px"
                  className={styles.videoDurationBadge}
                >
                  <Icon icon="HiVideoCamera" className={styles.videoDurationIcon} />
                  <Text className={styles.videoDurationText}>
                    {formattedDuration}
                  </Text>
                </Flex>
              )}

              <Flex
                align="center"
                justify="flex-end"
                gap="4px"
                className={styles.overlayTimeAndTick}
              >
                {timeAndTickContent}
              </Flex>
            </>
          )}

          {!isLoading && !isOverlay && !hideTimeAndTick && (
            <Flex
              align="center"
              justify="flex-end"
              gap="4px"
              className={" mbe-4 pi-12"}
            >
              {timeAndTickContent}
            </Flex>
          )}
        </Card>
      </div>
    </div>
  )
})
